module.exports = __webpack_public_path__ + "static/media/18.e4da02cc.png";